import { mapActions, mapState } from 'vuex'
import { fromScssToCss } from '@/helpers/filtersHelper.js'
import Style from '@/shared/components/Style'
import Collapsible from '@/shared/components/Collapsible'
import ColorPicker from '@/shared/components/ColorPicker'
import PlacementNumber from '@/shared/components/PlacementNumber'
import Dropdown from '@/shared/components/Dropdown'
import Spacement from '@/components/sidenav/shared/Spacement'
import Border from '@/components/sidenav/shared/Border'
import Button from '@/shared/components/Button'
import Input from '@/shared/components/Input'
import Divider from '@/shared/components/Divider'
import Toggle from '@/shared/components/Toggle'

export default {
  components: {
    Style,
    ColorPicker,
    PlacementNumber,
    Dropdown,
    Spacement,
    Button,
    Divider,
    Input,
    Border,
    Collapsible,
    Toggle,
  },
  props: {
    widget: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapState('landing', ['currentView']),
    options() {
      return this.widget.options
    },
  },
  methods: {
    ...mapActions('landing', ['removeWidget', 'updateOptions']),
    styleChanged(prefix, scss) {
      fromScssToCss(`${prefix} { ${scss} }`).then(css => {
        this.propChanged('style', { css, scss })
      })
    },
    propChanged(path, value) {
      this.updateOptions({
        id: this.widget.id,
        path,
        value,
      })
    },
  },
}
